import React, { useState } from "react";
import { Typography, Box } from "@mui/material";
import PropTypes from "prop-types";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import CommonInput from "../../../../CommonComponents/CommonInput";
import classes from "./CaseDescription.module.css";
import { useSelector } from "react-redux";

const CaseDescriptionElement = ({
  textBoxLabel,
  name,
  value,
  edit = false,
  onChange = () => {},
}) => {
  const [editable, setEditable] = useState(false);
  const addDescriptionHandler = () => {
    setEditable(true);
  };

  const blurHandler = (event) => {
    if(!event?.target?.value) setEditable(false);
  };

  // const { basic, policy, dispatch, claim, risk, endorsement } = useSelector(
  //   (state) => state.CaseDescriptionSlice.caseDescriptions
  // );

  return (
    <Box
      sx={{
        border: 1,
        width: "100%",
        height: "auto",
        background: "#FFFFFF",
        borderColor: "#E8E8E8",
        borderRadius: "4px",
        padding: "0.6rem",
      }}
    >
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: "1.3rem",
          lineHeight: "1.6rem",
          color: "#505050",
        }}
      >
        {textBoxLabel}
      </Typography>
      <Box
        sx={{
          background: "#FFFFFF",
          border: 1,
          borderColor: "#E8E8E8",
          borderRadius: "4px",
          maxWidth: "100%",
          height: "12.4rem",
          margin: "1.8rem 0rem 0rem 0rem",
          padding: "0.3rem",
          wordWrap: "break-word",
          overflowX: "auto",
        }}
      >
        {(editable || edit) && (
          <CommonInput
            className={classes["text-area-input"]}
            isTextArea
            onChange={onChange}
            onBlur={blurHandler}
            value={value}
            name={name}
          ></CommonInput>
        )}
        {!edit && (
          <>
            {!editable && (
              <Box
                sx={{
                  display: "flex",
                  gap: "4.4rem",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-around",
                }}
              >
                <Typography sx={{ mt: "3.1rem", color: "#B3B9C0" }}>
                  No Description
                </Typography>
                <IconButton
                  onClick={addDescriptionHandler}
                  sx={{
                    border: 1,
                    borderColor: "#59CE8F",
                    borderRadius: "4px",
                    width: "2rem",
                    height: "2rem",
                  }}
                >
                  <AddIcon sx={{ color: "#59CE8F" }} />
                </IconButton>
              </Box>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};
CaseDescriptionElement.propTypes = {
  textBoxLabel: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default CaseDescriptionElement;
